export default {"src":"/_next/static/media/logo-sequence.fb92cd0f.svg","height":140,"width":640,"blurWidth":0,"blurHeight":0};